<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="categorySelected"
    :clearable="!unclearable"
    :items="categoryItems"
    :loading="Loading"
    :search-input.sync="search"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="$t('financeBillEdit.category_selected')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
    :disabled="disabled"
    :readonly="readonly"
  ></v-autocomplete>
</template>

<script>
import searcherCategory from "@/api/finance_bills";
// import i18n from '../../i18n';

export default {
  name: "SearcherArea",

  props: {
    value: Object,
    stockId: Number,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    categoryItems() {
      return this.categories.map((e) => {
        const Description = e.category_name;
        // const disabled = this.disabledItems
        //   ? this.disabledItems.find(
        //       (disabledItem) => disabledItem.id == e.id
        //     )
        //   : false;
        return Object.assign({}, e, { Description });
      });
    },
  },

  data: () => ({
    categories: [],
    Loading: false,
    search: "",
    categorySelected: null,
  }),

  mounted() {
    this.getCategoryFromAPI();
  },

  methods: {
    getCategoryFromAPI() {
      this.Loading = true;
      searcherCategory.fetchAllForSelect({finance_bill_code: this.$route.query.financeBillCode})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.categories = response.data.categories;
              //适配没有设置库区的库位
            //   this.categories.unshift({
            //     id:0,
            //     area_name:i18n.t("StockArea.noStockArea"),
            //   })
              
            //   if(this.$route.query.financeBillCode){
            //     let result = this.categories.filter((v) => {
            //       return v.id == this.$route.query.financeBillCode;
            //     });
            //     this.categorySelected = result[0];
            //   }
            }
            this.Loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.Loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.categorySelected = this.value;
      },
    },
    categorySelected: {
      handler() {
        this.$emit("input", this.categorySelected);
      },
    },
    stockId: {
      handler() {
        this.getCategoryFromAPI();
      }
    }
  },
};
</script>
